import { render, staticRenderFns } from "./results.vue?vue&type=template&id=6a3345e0&scoped=true"
import script from "./results.vue?vue&type=script&setup=true&lang=js"
export * from "./results.vue?vue&type=script&setup=true&lang=js"
import style0 from "./results.vue?vue&type=style&index=0&id=6a3345e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3345e0",
  null
  
)

export default component.exports